import { FilterState } from './types';

export const createInitialFilterState = (): FilterState => ({
  health: [],
  owner: [],
  client: [],
  business: [],
  dealType: [],
  startDate: null,
  closeDate: null,
});

export const filtersToQueryParams = (
  filterState: FilterState,
  tabValue: number,
  searchTerm?: string,
  needsAttention?: boolean,
  selectedPipelines?: string[],
  mineOverride?: boolean,
  clientNameOverride?: string,
): Record<string, any> => {
  const params: Record<string, any> = {};

  params.mine = mineOverride ?? tabValue === 0;

  if (needsAttention) {
    params.needAttention = true;
  }

  if (filterState.health.length) {
    params.dealHealth = filterState.health.map((item) => item.Id).join(', ');
  }

  if (filterState.owner.length) {
    params.owner = filterState.owner.map((item) => item.Name).join(', ');
  }

  if (filterState.client.length) {
    params.clientName = filterState.client.map((item) => item.Name).join(', ');
  }

  if (clientNameOverride && clientNameOverride.trim()) {
    params.clientName = clientNameOverride.trim();
  }

  if (filterState.business.length) {
    params.business = filterState.business.map((item) => item.Name).join(', ');
  }

  if (filterState.dealType.length) {
    params.dealType = filterState.dealType.map((item) => item.Name).join(', ');
  }

  if (filterState.startDate) {
    params.closeDateFrom = filterState.startDate.format('YYYY-MM-DD');
  }
  if (filterState.closeDate) {
    params.closeDateTo = filterState.closeDate.format('YYYY-MM-DD');
  }

  if (searchTerm && searchTerm.trim()) {
    params.search = searchTerm.trim();
  }

  return params;
};
